<template>
  <div>
    <!--右侧内容-->
    <div class="class_add_top"> <a class="back" onclick="history.go(-1)">返回</a>编辑资源 </div>
    <div class="class_add_con">
      <form data-vv-scope="form">
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
          <tr class="tita">
            <td class="left_td">资源信息</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td class="left_td pt20">资源名称：</td>
            <td class="pt20">
              <input type="text" name="title" v-validate="'required'" v-model="params.title" placeholder="60字以内" v-bind:maxlength="60" class="put_495" />
              <div class="error_msg_tip">{{ errors.first('form.title') }}</div>
            </td>
          </tr>
          <tr>
            <td class="left_td pt20" valign="top">资源类型：</td>
            <td class="pt20">
              <p>
                <select name="type" v-validate="'required'" class="all_select" v-model="params.type" @change="changeResourceType(params.type)">
                  <option value="">--请选择--</option>
                  <option v-for='item in Dropdown.state.resourceType' :key="item.value" :value="item.value">{{item.label}}</option>
                </select>
              </p>
              <div class="error_msg_tip" v-show="errors.has('form.type')">请选择资源类型!</div>
            </td>
          </tr>
          <tr>
            <td class="left_td pt20" valign="top">资源封面：</td>
            <td valign="top" class="rdiv pt20">
              <input type="hidden" name="cover" v-validate="'required'" v-model="params.cover"/>
              <img v-if="params.cover && params.cover!==''" :src="params.cover"  class="upload_con" />
              <UploadOSS :uploadOSSConf="uploadOSSConf" :DOM_ID="'cover'" v-if="uploadOSSConf.STS!=null"  @success = "OSSUploadSuccess"></UploadOSS>
              <p class="mt10"><span class="tips_text">建议图片长500px宽500px，支持jpg、jpeg、png，图片大小不超过2MB</span></p>
              <div class="error_msg_tip" v-show="errors.has('form.cover')">请上传资源封面!</div>
            </td>
          </tr>
          <tr>
            <td class="left_td pt20" valign="top">上传到：</td>
            <td class="pt20 rdiv">
              <div class="treeSelect">
                <treeselect
                  :options="options"
                  :value="params.classificationId"
                  :searchable="false"
                  :show-count="true"
                  placeholder="--请选择分类--"
                  v-model="params.classificationId"
                >
                </treeselect>
              </div>
            </td>
          </tr>
          <tr v-if="resourceType!='' && resourceType=='2'">
            <td class="left_td pt20" valign="top">上传资源(视频)：</td>
            <td class="pt20 rdiv">
              <input type="hidden" name="filePathId" v-validate="'required'" v-model="params.filePathId"/>
              <UploadVod :uploadVodConf="uploadVodConf" v-if="uploadVodConf.STS!=null || uploadVodConf.Auth!=null" @success = "VodUploadSuccess"></UploadVod>
              <p class="mt10"><span class="tips_text">{{params.filePathMp4}}</span></p>
              <div class="error_msg_tip" v-show="errors.has('form.filePathId')">请上传资源!</div>
            </td>
          </tr>
          <tr v-if="resourceType!='' && resourceType!='2'">
            <td class="left_td pt20" valign="top">上传资源(其他)：</td>
            <td class="pt20 rdiv">
              <input type="hidden" name="filePathMp4" v-validate="'required'" v-model="params.filePathMp4"/>
              <UploadOSS :uploadOSSConf="uploadOSSConf_R" :DOM_ID="'filePathMp4'" v-if="uploadOSSConf_R.STS!=null"  @success = "OSSUploadSuccess_R"></UploadOSS>
              <p class="mt10"><span class="tips_text filePathMp4">{{params.filePathMp4}}</span></p>
              <div class="error_msg_tip" v-show="errors.has('form.filePathMp4')">请上传资源!</div>
            </td>
          </tr>
        </table>
        <p class="btn_center">
          <input type="button" class="all_btn" value="保存提交" @click="editResource('form')"/>
        </p>
      </form>
    </div>
    <!--/右侧内容-->
  </div>
</template>
<script>

import Dropdown from '@/store/modules/dropdowns'
import UploadOSS from '@/components/common/upload/uploadOSS.vue'
import UploadVod from '@/components/common/upload/uploadVod.vue'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import '@/utils/validator.js'
import { mapActions, mapState } from 'vuex'
export default {
  components: { Treeselect, UploadVod, UploadOSS },
  data () {
    return {
      Dropdown: Dropdown,
      options: [],
      params: {
        classification: null
      },
      resourceType: '',
      RCTree: [],
      uploadOSSConf: { showMode: '1', style: 'img_upload', typeArr: 'image/png,image/jpg,image/jpeg', catalog: 'byl', fileName: '', maxSize: '2000000', STS: null },
      uploadOSSConf_R: { showMode: '1', style: 'img_upload', typeArr: 'image/jpeg, image/png, audio/*, video/mp4, application/pdf, text/plain, application/vnd.ms-powerpoint, application/vnd.ms-excel, application/vnd.ms-works, application/msword', catalog: 'resource', fileName: '', maxSize: '102400000000', STS: null },
      uploadVodConf: { mode: 'STSMode', style: 'img_upload2', typeArr: 'video/*', catalog: 'byl', fileName: '', maxSize: '102400000000', STS: null, Auth: null },
      prefix: this.$route.meta.prefix || ''
   }
  },
  created () {
    if (this.$route.params.id === 'create') {
      this.params = {
        filePath: '',
        type: '',
        isPublic: '0',
        classificationId: null
      }
    } else {
      this.getResource(this.$route.params.id)
    }
    this.getResourceClassification()
  },
  mounted () {
    this.getSTS()
  },
  computed: {
    ...mapState('auth', ['user'])
  },
  methods: {
    OSSUploadSuccess (r) {
      if (r && r != '') {
        this.$set(this.params, r.dom_id, r.res.requestUrls[0])
      }
    },
    VodUploadSuccess (res) {
      if (res) {
        this.$set(this.params, 'filePathId', res.videoId)
      }
    },
    OSSUploadSuccess_R (r) {
      if (r && r != '') {
        this.$set(this.params, r.dom_id, r.res.requestUrls[0])
        $('.filePathMp4').html(this.params.filePathMp4)
      }e
    },
    getResource (id) {
      this.$api.get(this.$global.resourceApiPath, '/resource/' + id, {}, r => {
        if (r.data) {
          this.params = r.data
          this.resourceType = this.params.type
        }
      })
    },
    editResource (scope) {
      var self = this
      this.$validator.validateAll(scope).then(function (result) {
        if (result) {
          self.$api.post(self.$global.resourceApiPath, '/resource', self.params, r => {
            self.$router.push({path: self.prefix + '/org/resourceList'})
          })
        } else {
          self.$toasted.show('请确保信息正确与完整！', {
            duration: 800
          })
          return false
        }
      })
    },
    changeResourceType (type) {
      this.resourceType = type
      this.params.filePathId = ''
      this.params.filePathMp4 = ''
    },
    dealTree (arr) {
      var dealArr = []
      if (arr && arr.length > 0) {
        for (var i = 0; i< arr.length; i++) {
          var temp = {
            id: arr[i].id,
            label: arr[i].name
          };
          if (arr[i].nodes && arr[i].nodes.length > 0) {
            temp.children = []
            for (var j = 0; j < arr[i].nodes.length; j++) {
              var child = {
                id: arr[i].nodes[j].id,
                label: arr[i].nodes[j].name
              }
              temp.children.push(child)
            }
          }
          dealArr.push(temp)
        }
      }
      return dealArr
    },
    getResourceClassification () {
      this.$api.post(this.$global.resourceApiPath, '/resource/classification/list', {}, r => {
        let tree = r.data
        this.options = this.dealTree(tree)
      })
    },
    getSTS () {
      this.$api.get(this.$global.resourceApiPath, '/common/getSTS', {}, r => {
        let STS = [r.data.expiration, r.data.accessKeyId, r.data.accessKeySecret, r.data.securityToken, r.data.endpointClean, r.data.bucket, r.data.region]
        this.uploadOSSConf.STS = STS
        this.uploadVodConf.STS = STS
        this.uploadOSSConf_R.STS = STS
      })
    }
  }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/byl/org/resource/model.vue